import React from 'react'
import styled from '@emotion/styled'

const Main = styled.main`
  margin-top: 70px;
  padding: 1rem;
  line-height: 1.5rem;

  @media (min-width: 64em) {
    margin: 0 auto;
    max-width: 960px;
    padding-top: 90px;
  }
`

const Title = styled.h2`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;
`

const Section = styled.section`
  position: relative;

  a {
    text-decoration: none;
    color: initial;
  }
`

export default () => (
  <div>
    <Main>
      <Section>
        <Title id="munkalehetoseg">Munkalehetőség</Title>
        <p>
          <span>Munkát keresel? Csatlakozz folyamatosan bővülő csapatunkhoz! Jelentkezz elérhetőségeink egyikén:</span>
          <br />
          <br />
          <span>
            <span role="img" aria-label="telefon">
              ✆{' '}
            </span>
            <a href="tel:+36204504906">+36 20 4504 906</a>
          </span>
          <br />
          <span>
            <span role="img" aria-label="email">
              @{' '}
            </span>
            <a href="mailto:standard.kft@freemail.hu">standard.kft@freemail.hu</a>
          </span>
        </p>
        <p>Jelentkezni lehet az alábbi munkakörbe:</p>
        <ul>
          <li>kőműves</li>
          <li>ács</li>
          <li>tetőfedő</li>
          <li>vízszigetelő</li>
          <li>festő, gipszkartonos</li>
          <li>segédmunkás</li>
        </ul>
      </Section>
    </Main>
  </div>
)
